import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyWeeklyLifeActsComponent } from './myWeeklyLifeActs.component';
import { MyWeeklyLifeActsRoutingModule } from './myWeeklyLifeActs-routing.module';
import { ContainerModule } from '@app/components/container/container.module';
import { MyLifeActsMenuModule } from '@app/myWeeklyLifeActs/myLifeActsMenu/myLifeActsMenu.module';
import { MyLifeActsBlocksModule } from '@app/myWeeklyLifeActs/myLifeActsBlocks/myLifeActsBlocks.module';
import { TranslateModule } from '@ngx-translate/core';
import { ModalMyLifeActsBlocksModule } from '@app/myWeeklyLifeActs/modalMyLifeActsBlocks/modalMyLifeActsBlocks.module';
import { ButtonModule } from '@app/components/button/button.module';
import { LoaderModule } from '@shared/loader/loader.module';
import { MyLifeActsDownloadButtonModule } from '@app/myWeeklyLifeActs/myLifeActsDownloadButton/myLifeActsDownloadButton.module';

@NgModule({
  imports: [
    CommonModule,
    ContainerModule,
    ModalMyLifeActsBlocksModule,
    MyLifeActsBlocksModule,
    MyLifeActsMenuModule,
    MyWeeklyLifeActsRoutingModule,
    TranslateModule,
    ButtonModule,
    LoaderModule,
    MyLifeActsDownloadButtonModule,
  ],
  declarations: [MyWeeklyLifeActsComponent],
})
export class MyWeeklyLifeActsModule {}
